import React, { useState, useRef } from "react";
import "./ForgotPassword.css";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import axios from "axios";
import { security_key, BASE_URL } from "../global";
import LinearProgress from "@mui/material/LinearProgress";
import Image from "react-bootstrap/Image";

const validationSchema = Yup.object().shape({
    patient_email: Yup.string().email("Invalid email").required("Email is required").strict(),
});

function ForgotPassword() {
    const navigate = useNavigate();

    const formRef = useRef(null);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const initialValues = {
        patient_email: "",
    };

    const { values, handleBlur, touched, handleChange, errors, handleSubmit, setTouched, resetForm, setValues } = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: async (formValues) => {
            setIsSubmitting(true);

            // navigate("/Patient/PatientOTP");

            try {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "checkPatientEmail",
                    ...formValues,
                });

                const output = response.data;

                // console.log("Response Data:", output);

                if (output["status"] == 1) {
                    toast.success(output["message"], {
                        autoClose: 3000,
                    });
                    sessionStorage.setItem("email", values.patient_email);
                    setTimeout(function () {
                        navigate("/Patient/PatientOTP");
                    }, 3000);
                } else {
                    toast.error(output["message"], {
                        autoClose: 3000,
                    });
                }

                setIsSubmitting(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Invalid API. Please Contact Emstyle Team", {
                    autoClose: 1000,
                });
            }
        },
    });

    return (
        <>
            <ToastContainer position="top-center" />

            <div className="forgot_wrap">
                <div className="app app-auth-sign-in align-content-stretch d-flex flex-wrap justify-content-end" style={{ background: "#e7ebf8" }}>
                    <div className="app-auth-background patient-login"></div>
                    <div className="app-auth-container">
                              {/* <div className="d-flex justify-content-center mb-4">
              {" "}
              <Image
                src="../images/logo-light.png"
                width={180}
                className="img-fluid   d-block d-md-none"
              />
            </div> */}
                           <div className="logo-dark mb-3 text-center">
              
                               
                                <Image src="../images/logo-dark.png" width={150} className="img-fluid  logo-dark" />
                       
                        </div>
                                <div className="logo-light mb-3 text-center">
                           
                                <Image src="../images/logo-light.png" width={150} className="img-fluid  " />
                       
                        </div>
         <div className="inner-content">       <div className="auth-credentials mb-0 bg-none bg-0 border-0  m-b-xxl" style={{backgroundColor:"transparent"}}>
                            <Form autoComplete="off" onSubmit={handleSubmit} ref={formRef}>
                                {/* <h4 className="text-center mb-4">Forgot Password?</h4> */}
                                <div className="form-group mb-3">
                                    <Form.Label>
                                        Enter your email address
                                        <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="patient_email"
                                        value={values.patient_email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        className={errors.patient_email && touched.patient_email ? "input-error" : ""}
                                    />
                                    {errors.patient_email && touched.patient_email && <p className="error">{errors.patient_email}</p>}
                                </div>
                                <div className="form-group text-center">
                                    <button className="btn btn-primary sign-in-btn" type="submit" disabled={isSubmitting}>
                                        Submit
                                        {isSubmitting ? <LinearProgress /> : ""}
                                    </button>
                                </div>
                            </Form>
                        </div></div>
                 
                    </div>
                </div>
            </div>
        </>
    );
}

export default ForgotPassword;
